import { Table } from '@dixa/lib-shared-habla';

import { formatMoney, lineItemLabel } from './userActivityTypes.utils';

type LineItemLike = {
  readonly reference?: string;
  readonly label: string;
  readonly quantity: number;
  readonly amount?: { readonly amount: number; readonly currency: string };
};

type LineItemsProps = {
  readonly items: readonly LineItemLike[];
};

/** The line-item breakdown, rendered as a compact Item / Qty / Amount table. */
export const LineItems = ({ items }: LineItemsProps): JSX.Element => {
  const hasAmount = items.some((item) => item.amount);

  return (
    <Table framed={false} headerWithBackground={false}>
      <Table.Thead>
        <Table.Tr>
          <Table.Th columnId={null}>Item</Table.Th>
          <Table.Th columnId={null} align="right">
            Qty
          </Table.Th>
          {hasAmount && (
            <Table.Th columnId={null} align="right">
              Amount
            </Table.Th>
          )}
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        {items.map((item, index) => (
          <Table.Tr key={index}>
            <Table.Td>{lineItemLabel(item)}</Table.Td>
            <Table.Td align="right">{item.quantity}</Table.Td>
            {hasAmount && (
              <Table.Td align="right">
                {item.amount ? formatMoney(item.amount) : '—'}
              </Table.Td>
            )}
          </Table.Tr>
        ))}
      </Table.Tbody>
    </Table>
  );
};
